import { Injectable } from "@angular/core";
import { CanActivateFn } from '@angular/router';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router
} from "@angular/router";
import { Observable } from "rxjs";
import { map, tap } from "rxjs/operators";
import { AuthService } from "../services/auth.service";


@Injectable({
  providedIn: "root"
})

export // export const guestGuard: CanActivateFn = (route, state) => {
class GuestGuard implements CanActivate {
  // return true;
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.authService.isAuthenticated.pipe(
      map(isAuthenticated => {
        if (!isAuthenticated) {
          return true;
        } else {
          return this.router.createUrlTree(["/"]);
        }
      })
    );
  }
};
